var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",attrs:{"id":"dashboard-container"}},[_c('to-do-index',{attrs:{"showing":_vm.showing}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }